import FrameworkCourseController from "../diagrams/framework-course.controller";

class ScqDiagramController extends FrameworkCourseController {

  constructor(courseService, diagramService, $translate, $timeout, $scope) {
    'ngInject';
    super(courseService, diagramService, $translate, $timeout, $scope);
    this.scqDiagram = true;
  }

  // $postLink() {
  //   setTimeout(() => this.diagramService.initSCQDiagram(this.diagramId), 1000);
  // }

  $onInit() {
    this.amountCorrectAnswers = this.data.answers.length;
    this.diagramId = this.data.id
    super.$onInit()
  }

  submit(callNotFromHint = true) {
    this.submitCount++;
    const boxesWithIncorectAnswers = $(`#${this.diagramId} .answer__incorrect`);
    const boxesWithCorectAnswers = $(`#${this.diagramId} .answer__correct`);
    // if ((boxesWithCorectAnswers.length + boxesWithIncorectAnswers.length) === this.data.blocks.length) {
    this.submited = true;
    // }

    if (!boxesWithIncorectAnswers.length && boxesWithCorectAnswers.length === this.amountCorrectAnswers) {
      this.courseService.play('buttonClick');
      this.diagramComplete = true;
      this.diagramService.disableSCQDiagram(this.diagramId);
      setTimeout(() => this.courseService.play('exerciseComplete'), 500);
      this.finishExercise();
    } else if (callNotFromHint) {
      this.courseService.play('wrongAnswer');
    }

  }

  hint() {
    let submit = this.submit
    submit = submit.bind(this)
    super.hint(true, submit)
  }
}

export default ScqDiagramController;



// WEBPACK FOOTER //
// ./client/app/components/scq-diagram-dnd/scq-diagram.controller.js